query languages {
  languages {
    id
    langISOCode
  }
}
